import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { createSlice } from "@reduxjs/toolkit";
var initialState = {
    data: null,
    isFetching: false,
    isError: false
};
var updateCommentBusiness = createSlice({
    name: "updateCommentBusiness",
    initialState: initialState,
    reducers: {
        fetchData: function(state) {
            state.isFetching = true;
            state.data = null;
            state.isError = false;
        },
        fetchDataSuccess: function(state, action) {
            return _object_spread_props(_object_spread({}, state), {
                isFetching: false,
                data: action.payload
            });
        },
        fetchDataFailure: function(state) {
            return _object_spread_props(_object_spread({}, state), {
                isFetching: false,
                isError: true
            });
        },
        resetState: function() {
            return initialState;
        }
    }
});
var _updateCommentBusiness_actions = updateCommentBusiness.actions;
export var fetchData = _updateCommentBusiness_actions.fetchData, fetchDataSuccess = _updateCommentBusiness_actions.fetchDataSuccess, fetchDataFailure = _updateCommentBusiness_actions.fetchDataFailure, resetState = _updateCommentBusiness_actions.resetState;
export default updateCommentBusiness.reducer;
